import styled from "styled-components";
import {FlexContainer,PrimaryButton } from "./styled";
import {useUserContext} from "../context/UserContext";
import { useState,useEffect } from "react";
import { useDeck } from "../context/DeckContext";
import { hearthbeat } from "./styled/animations";
// import { getJetonPrices } from "../service/ton";
import {rechargeEnergy } from "../service/main/api";
import EnergFleskImage from "../assets/images/energyFlesk.png";
import {useToaster} from "../hooks/useToaster";
import {useLoading} from "../context/LoadingContext";

const RechargeModalContent = ({onClose,navigate}) => {
    const {fetchUser,user,energyItems} = useUserContext();
    const {deck,userCards} = useDeck();
    const [cost, setCost] = useState(1);
    const [energyFlesks, setEnergyFlesks] = useState(0);
    const { setIsLoading } = useLoading();
    const { showToaster } = useToaster();
    // const calculateRechargeCost = (slots,prices) => {
    //     if (slots < 3 || slots > 24) {
    //         return;
    //     }
    //     if(!prices) return;
    //     const sortedCards = userCards.sort((a, b) => b.miningPower - a.miningPower);
    //     let maxMiningPower = 0;
    //     for (let i = 0; i < slots; i++) {
    //         maxMiningPower += sortedCards[i].miningPower;
    //     }
    //     console.log("maxMiningPower",maxMiningPower);
    //     let cost = (maxMiningPower * prices.nova * 0.07) / prices.cpt;
    //     console.log("cost",cost);

    //     // const baseCost = 4;
    //     // const linearScaling = 0.1 * (slots - 3);
    //     // const nonlinearScaling = (slots ** 2) / 1000;
    //     // const cost = baseCost * (1 + linearScaling + nonlinearScaling);
    //     if(cost < 1) return 1 * 20;

    //     return Math.floor(cost * 20);
    // };
    const getEnergyFlesks = async () => {
        setIsLoading(true);
        let energyFleskId = energyItems.find(item => item.name === "Energy Flesk")?._id;
        console.log("Energy Flesk ID:", energyFleskId);
        const data = user.energyItems ? user.energyItems[energyFleskId] || 0 : 0;
        console.log("Energy Flesks:", data);
        setEnergyFlesks(data);
        setIsLoading(false);
    }
    useEffect(() => {
        if(!deck) return;
        getEnergyFlesks();
      
        
        // if(!walletDetails) return;
        // setDestinationAddress(walletDetails.cpt.address);
        // setWalletBalance(walletDetails.cpt.balance);

    }, [deck]);
    
    const handleRecharge = async () => {
        if(userCards.energy > 0 ){
            showToaster({ type: "error", message: `Energy must be 0,Your energy is ${userCards.energy}` });
            onClose();
            return;
        }
        if(cost > energyFlesks){
           
            showToaster({ type: "error", message: "You don't have enough Energy Flesks." });
            onClose();
            return;
        }
        setIsLoading(true);
         const res = await rechargeEnergy({});
         if(res?.success){       
            setIsLoading(false);
            showToaster({ type: "success", message: "Recharge success" });
            onClose();
            setTimeout(() => {
                 fetchUser();
            }, 2000);
                    
        }else{
            setIsLoading(false);
            showToaster({ type: "error", message: res.message });
             onClose();
             
             
         }
    }

    return (
        <FlexContainer flexdirection="column">
              <IconButtonContainer>
            <MiddleContainer>
                  Energy:<span>0% {">>"} 100%</span>   
            </MiddleContainer>
            </IconButtonContainer>
            <CostContainer>
                 <span>Cost:</span>
                 <img src={EnergFleskImage} alt="Cpt Icon" />
                <span>{cost} Energy Flesk</span>
            </CostContainer>
            <PrimaryButton style={{width:"120px"}} onClick={handleRecharge}>Recharge</PrimaryButton>
            <StyledText>Energy Flesk: <img style={{width:"24px"}} src={EnergFleskImage}  alt="flesk"/> {Number(energyFlesks).toLocaleString(undefined, { maximumFractionDigits: 2 }) || 0}</StyledText>
        </FlexContainer>
    );
};


 const IconButtonContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;   
    gap: 10px;
    margin-top: 16px;
`
 const MiddleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap:nowrap;
    gap: 4px;
    background: #63636333;
    border-radius: 100px;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    width: 150px;
    height: 42px;
    color:white;
    width: 100%;
    max-width:252px;
    span{
        color:#7AE637;
    }
`

const StyledText = styled.span`
    font-size: 0.8em;
    font-weight: 400;
    font-weight: 600;
    color: #FFFFFF;
    margin: 16px 0;
    display: flex;
    align-items: center;
`
const CostContainer = styled(FlexContainer)`
    height: 100%;
    margin-top: 16px;
    gap: 8px;
    img{
        width: 32px;
    }
`
const Container = styled.div`
    width: 100%;
    padding: 0 16px;
    padding-bottom: 34px;
    `

const StyledImage = styled.img`
    /* width: 100%; */
    width:100%;
    max-width: 88px;
    animation: ${hearthbeat} 1.5s ease-in-out infinite both;
`
const StyledText2 = styled.p`
    font-size: 1.2rem;
    text-align: center;
    margin-top: 2vh;
`
export default RechargeModalContent;